<template>
  <div class="alt-ios-native-select" :class="{ 'is-active': active }">
    <select data-testid="checkout-select-2" v-if="active" :value="$attrs.value" @change="update" tabindex="-1" aria-hidden="true" @click.stop>
      <option data-testid="checkout-option-3" value="" selected></option>
      <option data-testid="checkout-option-4" v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    active() {
      return (
        this.is_mobile_reactive &&
        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform)
      );
    },
  },
  methods: {
    update(event) {
      this.$emit('input', event.target.value);
    },
  },
  mounted() {
    const style = this.$slots.default()?.[0]?.elm?.style ?? {};
    ['width', 'position', 'display'].forEach((p) => {
      this.$el.style[p] = style[p];
    });
  },
};
</script>

<style lang="scss" scoped>
.alt-ios-native-select {
  select {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  &.is-active :deep .zbo-select .zbo-scrollbar__bar {
    display: none !important;
  }
}
</style>
